"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerErrorFromProtocol = exports.InternalServerError = exports.ServiceUnavailableErrorFromProtocol = exports.ServiceUnavailableError = exports.TooManyRequestsErrorFromProtocol = exports.TooManyRequestsError = exports.EntityExistsErrorFromProtocol = exports.EntityExistsError = exports.RouteNotFoundFromNotFoundErrorFromProtocol = exports.NotFoundErrorFromProtocol = exports.NotFoundError = exports.ForbiddenErrorFromProtocol = exports.ForbiddenError = exports.NotAuthorizedErrorFromProtocol = exports.NotAuthorizedError = exports.NotAuthenticatedErrorFromProtocol = exports.NotAuthenticatedError = exports.LegacyValidationErrorFromProtocol = exports.LegacyValidationError = exports.HttpApiDecodeErrorFromValidationErrorFromProtocol = exports.ValidationErrorFromProtocol = exports.ValidationError = exports.ErrorFromProtocol = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Protocol = __importStar(require("../protocol"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Error';
/**
 * Given a schema for a TaggedError, returns a schema that encodes this error
 * to the format defined by our own wire protocol.
 */
const ErrorFromProtocol = (target) => {
    // Here we derive a source schema from the target.
    // We use the encoded side of the target, but with "_tag" renamed to "type".
    // That becomes the "error" property of a wrapper type that also has a "success: false" prop.
    const encodedTarget = effect_1.Schema.encodedSchema(target);
    const source = effect_1.Schema.Struct({
        success: effect_1.Schema.tag(false),
        error: encodedTarget.pipe(effect_1.Schema.omit('_tag'), effect_1.Schema.extend(encodedTarget.pipe(effect_1.Schema.pick('_tag'), effect_1.Schema.rename({ _tag: 'type' }))), effect_1.Schema.typeSchema),
    });
    return effect_1.Schema.transform(source, target, {
        strict: false, // because TS doesn't understand that the source was derived from the target
        decode: ({ error: { type, ...error } }) => ({ _tag: type, ...error }),
        encode: ({ _tag, ...error }) => Protocol.Failure({ type: _tag, ...error }),
    });
};
exports.ErrorFromProtocol = ErrorFromProtocol;
class ValidationError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.ValidationError`)('ValidationError', {
    message: effect_1.Schema.String,
    issues: effect_1.Schema.Array(Protocol.ValidationIssue),
}) {
}
exports.ValidationError = ValidationError;
exports.ValidationErrorFromProtocol = (0, exports.ErrorFromProtocol)(ValidationError).annotations({
    identifier: `${exports.NAMESPACE}.ValidationErrorFromProtocol`,
    title: 'Validation Error',
    description: 'One of the request entities does not satisfy business rules',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
/**
 * Converts an Effect HttpApiDecodeError to a ValidationErrorFromProtocol
 *
 * Note that the transformation is lossy, and decoding will fail.
 */
exports.HttpApiDecodeErrorFromValidationErrorFromProtocol = effect_1.Schema.transformOrFail(effect_1.Schema.encodedBoundSchema(exports.ValidationErrorFromProtocol), platform_1.HttpApiError.HttpApiDecodeError, {
    strict: true,
    decode: (actual, _, ast) => {
        return effect_1.ParseResult.fail(new effect_1.ParseResult.Forbidden(ast, actual, 'Cannot decode a ValidationError into an HttpApiDecodeError; ' +
            'Make sure that ValidationErrorFromProtocol is one of the members of your ErrorSchema'));
    },
    encode: x => {
        return effect_1.ParseResult.succeed({
            success: false,
            error: {
                type: 'ValidationError',
                issues: x.issues,
                message: x.message,
            },
        });
    },
}).annotations({
    identifier: `${exports.NAMESPACE}.HttpApiDecodeErrorFromValidationErrorFromProtocol`,
    title: 'Validation Error',
    description: 'One of the request entities does not satisfy business rules',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
class LegacyValidationError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.LegacyValidationError`)('LegacyValidationError', {
    message: effect_1.Schema.String,
    inputValidation: effect_1.Schema.Array(Protocol.LegacyInputValidation),
}) {
}
exports.LegacyValidationError = LegacyValidationError;
exports.LegacyValidationErrorFromProtocol = (0, exports.ErrorFromProtocol)(LegacyValidationError).annotations({
    identifier: `${exports.NAMESPACE}.LegacyValidationErrorFromProtocol`,
    title: 'Validation Error (Legacy Format)',
    description: 'One of the request entities does not satisfy business rules',
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
class NotAuthenticatedError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.NotAuthenticatedError`)('NotAuthenticatedError', { message: effect_1.Schema.String }) {
}
exports.NotAuthenticatedError = NotAuthenticatedError;
exports.NotAuthenticatedErrorFromProtocol = (0, exports.ErrorFromProtocol)(NotAuthenticatedError).annotations({
    identifier: `${exports.NAMESPACE}.NotAuthenticatedErrorFromProtocol`,
    title: 'Not Authenticated',
    description: 'The resource requires a (different) form of authentication',
    [platform_1.HttpApiSchema.AnnotationStatus]: 401,
});
class NotAuthorizedError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.NotAuthorizedError`)('NotAuthorizedError', { message: effect_1.Schema.String }) {
}
exports.NotAuthorizedError = NotAuthorizedError;
exports.NotAuthorizedErrorFromProtocol = (0, exports.ErrorFromProtocol)(NotAuthorizedError).annotations({
    identifier: `${exports.NAMESPACE}.NotAuthorizedErrorFromProtocol`,
    title: 'Not Authorized',
    description: 'The authenticated actor is not authorized to make the request',
    [platform_1.HttpApiSchema.AnnotationStatus]: 401,
});
class ForbiddenError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.ForbiddenError`)('ForbiddenError', { message: effect_1.Schema.String }) {
}
exports.ForbiddenError = ForbiddenError;
exports.ForbiddenErrorFromProtocol = (0, exports.ErrorFromProtocol)(ForbiddenError).annotations({
    identifier: `${exports.NAMESPACE}.ForbiddenErrorFromProtocol`,
    title: 'Forbidden',
    description: 'The authenticated actor is not authorized to make the request',
    [platform_1.HttpApiSchema.AnnotationStatus]: 403,
});
class NotFoundError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.NotFoundError`)('NotFoundError', { message: effect_1.Schema.String }) {
}
exports.NotFoundError = NotFoundError;
exports.NotFoundErrorFromProtocol = (0, exports.ErrorFromProtocol)(NotFoundError).annotations({
    identifier: `${exports.NAMESPACE}.NotFoundErrorFromProtocol`,
    title: 'Not Found',
    description: 'The requested resource could not be found',
    [platform_1.HttpApiSchema.AnnotationStatus]: 404,
});
exports.RouteNotFoundFromNotFoundErrorFromProtocol = effect_1.Schema.transformOrFail(exports.NotFoundErrorFromProtocol, effect_1.Schema.instanceOf(platform_1.HttpServerError.RouteNotFound), {
    strict: true,
    encode: err => effect_1.ParseResult.succeed(new NotFoundError({ message: err.message })),
    decode: (actual, _, ast) => {
        return effect_1.ParseResult.fail(new effect_1.ParseResult.Forbidden(ast, actual, 'Cannot decode a NotFoundError into a RouteNotFound'));
    },
}).annotations({
    identifier: `${exports.NAMESPACE}.RouteNotFoundFromNotFoundErrorFromProtocol`,
    title: 'Endpoint Not Found',
    description: 'The requested route does not exist',
    [platform_1.HttpApiSchema.AnnotationStatus]: 404,
});
class EntityExistsError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.EntityExistsError`)('EntityExistsError', { message: effect_1.Schema.String }) {
}
exports.EntityExistsError = EntityExistsError;
exports.EntityExistsErrorFromProtocol = (0, exports.ErrorFromProtocol)(EntityExistsError).annotations({
    identifier: `${exports.NAMESPACE}.EntityExistsErrorFromProtocol`,
    title: 'Entity Exists',
    description: 'An entity creation or update conflict occurred',
    [platform_1.HttpApiSchema.AnnotationStatus]: 409,
});
class TooManyRequestsError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.TooManyRequestsError`)('TooManyRequestsError', { message: effect_1.Schema.String }) {
}
exports.TooManyRequestsError = TooManyRequestsError;
exports.TooManyRequestsErrorFromProtocol = (0, exports.ErrorFromProtocol)(TooManyRequestsError).annotations({
    identifier: `${exports.NAMESPACE}.TooManyRequestsErrorFromProtocol`,
    title: 'Too Many Requests',
    description: 'A rate limit applies to the request',
    [platform_1.HttpApiSchema.AnnotationStatus]: 429,
});
class ServiceUnavailableError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.ServiceUnavailableError`)('ServiceUnavailableError', {
    message: effect_1.Schema.String,
    reason: effect_1.Schema.Literal('IndexDisabled', 'IndexLoading'),
    retryAfterSeconds: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
}) {
}
exports.ServiceUnavailableError = ServiceUnavailableError;
exports.ServiceUnavailableErrorFromProtocol = (0, exports.ErrorFromProtocol)(ServiceUnavailableError).annotations({
    identifier: `${exports.NAMESPACE}.ServiceUnavailableErrorFromProtocol`,
    title: 'Service Unavailable',
    description: 'The device map index is disabled or still loading',
    [platform_1.HttpApiSchema.AnnotationStatus]: 503,
});
class InternalServerError extends effect_1.Schema.TaggedError(`${exports.NAMESPACE}.InternalServerError`)('InternalServerError', { message: effect_1.Schema.String }) {
}
exports.InternalServerError = InternalServerError;
exports.InternalServerErrorFromProtocol = (0, exports.ErrorFromProtocol)(InternalServerError).annotations({
    identifier: `${exports.NAMESPACE}.InternalServerErrorFromProtocol`,
    title: 'Internal Server Error',
    description: 'Something went wrong while processing the request',
    [platform_1.HttpApiSchema.AnnotationStatus]: 500,
});
//# sourceMappingURL=error.js.map